module.exports = __webpack_public_path__ + "media/images/logo__legionxiii-9aea3acdd38672a91190e02bb4cebf72.png";